import React, { useEffect, useState, useRef } from 'react';
import 'animate.css';

import './ChatWindow.css';
import imagenLina from '../../assets/img/Lina.png';
import iconoClavelina from '../../assets/img/icono-clavelina.svg';
import linaChatIcon from '../../assets/img/lina-chat-icon.svg';
import { useChat } from '../context/ChatContext';

// --- COMPONENTE HIJO: RESUMEN DE PEDIDO ---
const ResumenPedido = ({ pedidoActual = [], modoEntrega, datosEnvio = {} }) => {
  if (!pedidoActual || pedidoActual.length === 0) return null;

  const calcularTotalItems = () => {
    return pedidoActual.reduce((total, item) => {
      const cantidadTexto = (item.cantidad || "").toString().toLowerCase().trim();
      let cantidad = 0;
  
      // 1. Detectar fracciones comunes
      if (cantidadTexto.includes('¼')) cantidad = 0.25;
      else if (cantidadTexto.includes('½')) cantidad = 0.5;
      else if (cantidadTexto.includes('¾')) cantidad = 0.75;
      
      // 2. Lógica para Gramos (Ej: "450 gr" o "450 gramos")
      else if (cantidadTexto.includes('gr') || cantidadTexto.includes('gramo')) {
        const valorNumerico = parseFloat(cantidadTexto.replace(/[^\d.]/g, ''));
        cantidad = isNaN(valorNumerico) ? 0 : valorNumerico / 1000; // Convertimos a kg
      }
      
      // 3. Lógica para Kilos o números directos
      else {
        // Extraemos solo el número por si dice "1 kilo" o "2kg"
        const valorNumerico = parseFloat(cantidadTexto.replace(/[^\d.]/g, ''));
        cantidad = isNaN(valorNumerico) ? 1 : valorNumerico;
      }
  
      return total + cantidad;
    }, 0);
  };

  return (
    <div className="resumen-pedido card mt-3 border-success shadow-sm animate__animated animate__fadeInUp animate__faster">
      <div className="card-header bg-success text-white py-2">
        <h6 className="mb-0 fs-6">🧾 Resumen de tu pedido</h6>
      </div>
      <div className="card-body p-3">
        {pedidoActual.map((item, idx) => (
          <div key={`${item.producto}-${idx}`} className="d-flex justify-content-between border-bottom pb-2 mb-2">
            <div className="pe-2">
              <span className="fw-bold">{item.cantidad}</span> de <span className="fw-bold">{item.producto}</span>
              {item.corte && item.corte !== 'Sin corte' && (
                <div className="text-muted small">
                  <i className="bi bi-scissors me-1"></i> Corte: {item.corte}
                </div>
              )}
            </div>
            <div className="text-end">
              <span className="badge bg-light text-dark border">{item.categoria}</span>
            </div>
          </div>
        ))}
      <div className="mt-3 pt-2 border-top">
  <div className="d-flex justify-content-between mb-1">
    <span className="text-muted small">Peso/Cant. Total:</span>
    <span className="fw-bold">
      {/* 1. Guardamos el total en una constante para no llamar a la función dos veces 
          2. Usamos toFixed(2) para que siempre se vea limpio (ej: 1.50)
      */}
      {(() => {
        const total = calcularTotalItems();
        return `${total.toFixed(2)} kg`;
      })()}
    </span>
  </div>

          <div className="d-flex justify-content-between mb-1">
            <span className="text-muted small">Método:</span>
            <span className={`fw-bold small ${modoEntrega === 'delivery' ? 'text-primary' : modoEntrega === 'retiro' ? 'text-success' : 'text-danger'}`}>
              {modoEntrega === 'delivery' ? '🚚 Delivery' : modoEntrega === 'retiro' ? '🏪 Retiro' : '❓ Pendiente'}
            </span>
          </div>
          {modoEntrega === 'delivery' && datosEnvio?.direccion && (
            <div className="mt-2 p-2 bg-light rounded border-start border-primary border-3 animate__animated animate__flash">
              <div className="small text-muted mb-1" style={{ fontSize: '0.75rem' }}>📍 DESTINO:</div>
              <div className="small lh-1">{datosEnvio.direccion}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// --- COMPONENTE PRINCIPAL ---
export default function ChatWindow() {
  const { 
    messages, enviar, estado, cargando, 
    pedidoId, pedidoActual, modoEntrega, datosEnvio,
    confirmarRecepcion, enviarLlegadaDirecta, mostrarBotonEntrega ,resetParaNuevoPedido
  } = useChat();

  const chatRef = useRef(null);
  const [input, setInput] = useState('');
  const [modo, setModo] = useState("day"); 
  const nombreCliente = localStorage.getItem('nombre_cliente') || 'cliente';

  // Auto-scroll cada vez que llegan mensajes
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  const handleCaptureUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => enviar(reader.result, {}, true);
    reader.readAsDataURL(file);
  };

  const handleEnviarTexto = () => {
    if (!input.trim()) return;
    enviar(input);
    setInput('');
  };

  const manejarSeleccion = (opcion) => {
    if (opcion.valor === 'ir_al_home') {
      // 1. Enviamos un mensaje manual al chat para que parezca que el usuario lo dijo
      // O simplemente dejamos que el estado cambie. 
      // Pero para que LINA responda, lo mejor es avisar al Backend:
      
      enviar("Gracias, volver al inicio", { valor: 'ir_al_home' });

      // 2. Usamos un temporizador (setTimeout) para dar tiempo a leer
      // 7000 = 7 segundos de gracia
      console.log("👋 Lina se está despidiendo... redireccionando en 2.5s");
      
      setTimeout(() => {
        window.location.href = '/inicio'; //  ruta local actual
      }, 7000);
      
      return; // Detenemos aquí para que no haga nada más
    }

    if (opcion.valor === 'otro_pedido') {
      resetParaNuevoPedido();
      enviar("Quiero hacer otro pedido", {}, true);
      return;
    }

    enviar(opcion.valor || opcion.texto);
  };
  const renderBotones = () => {
    const ultimoMsg = messages[messages.length - 1];
    const textoLina = ultimoMsg?.text || "";

    // --- 1. DETECCIÓN DE FINALIZACIÓN (Incluso si el estado no ha cambiado aún) ---
    // Si el estado es el correcto O si Lina ya se despidió textualmente
    if (estado === 'MENU_POST_PEDIDO' || 
        textoLina.includes("¡Gracias por tu compra!") || 
        textoLina.includes("disfruta tu pedido")) {
      return (
        <div className="w-100 animate__animated animate__fadeInUp">
          <div className="alert alert-light border-success text-center mb-3 shadow-sm">
            ✨ <strong>¡Pedido finalizado con éxito!</strong><br/>
            ¿Deseas realizar otra compra o volver al inicio?
          </div>
          <div className="d-flex gap-2">
            <button className="btn btn-success flex-grow-1 py-3 fw-bold shadow-sm" 
              onClick={() => manejarSeleccion({ valor: 'otro_pedido' })}>
              🛒 Nuevo Pedido
            </button>
            <button className="btn btn-outline-secondary flex-grow-1 py-3 shadow-sm" 
              onClick={() => manejarSeleccion({ valor: 'ir_al_home' })}>
              🏠 Ir al Inicio
            </button>
          </div>
        </div>
      );
    }

    // --- 2. Estados de Entrega y Pago ---
    if (estado === 'ENTREGADO' || estado === 'COMPLETADO_DELIVERY') {
      return (
        <div className="w-100 animate__animated animate__fadeInUp">
          <div className="alert alert-success shadow-sm text-center mb-2">
            <i className="fas fa-box-open me-2"></i><strong>¡Pedido entregado!</strong>
          </div>
          <button className="btn btn-success shadow-sm px-4 py-3 w-100 fw-bold animate__animated animate__pulse animate__infinite" 
            onClick={() => confirmarRecepcion(pedidoId)}>
            <i className="fas fa-check-circle me-2"></i> Sí, ya lo recibí
          </button>
        </div>
      );
    }

    if (estado === 'EN_RUTA') {
      return (
        <div className="alert alert-info w-100 text-center animate__animated animate__pulse animate__infinite">
          <i className="fas fa-motorcycle me-2"></i> <strong>¡Tu pedido va en camino!</strong>
        </div>
      );
    }

    // Solo mostramos "Ya estoy aquí" si NO estamos en el flujo de despedida
    if (estado === 'LISTO_PARA_RETIRO' && !textoLina.includes("Ya le he avisado")) {
      return (
        <button className="btn btn-success shadow-sm px-4 py-2 w-100 fw-bold animate__animated animate__fadeInUp" onClick={enviarLlegadaDirecta}>
          Ya estoy aquí en la tienda 🏪
        </button>
      );
    }

    if (estado === 'METODO_PAGO') {
      return (
        <div className="d-flex flex-wrap justify-content-center gap-2 w-100 animate__animated animate__fadeInUp">
          {/* Pasamos { pedidoActual: null } para evitar que el array vacío del cliente 
            borre los productos cargados por el administrador en la base de datos.
          */}
          <button 
            className="btn btn-success shadow-sm px-3" 
            onClick={() => enviar('Pago Móvil')}
          >
            📱 Pago Móvil
          </button>
    
          <button 
            className="btn btn-success shadow-sm px-3" 
            onClick={() => enviar('Efectivo')}
          >
            💵 Efectivo
          </button>
    
          <button 
            className="btn btn-success shadow-sm px-3" 
            onClick={() => enviar('Debito')}
          >
            💳 Débito
          </button>
        </div>
      );
    }
    // --- 3. Opciones Dinámicas ---
    if (ultimoMsg?.sender === 'bot' && ultimoMsg.opciones?.length > 0) {
      if (ultimoMsg.opciones.length > 6) {
        return (
          <div className="row g-2 justify-content-center w-100 custom-cards-container">
            {ultimoMsg.opciones.map((op, idx) => (
              <div key={idx} className="col-6 col-md-4 animate__animated animate__fadeInUp" style={{ animationDelay: `${idx * 0.05}s` }}>
                <div className="card h-100 border-success shadow-sm text-center p-2">
                  <div className="card-body p-1 d-flex flex-column">
                    <i className="fas fa-tag text-success mb-2 opacity-50"></i>
                    <p className="card-text small fw-bold mb-2 lh-sm">{op.texto}</p>
                    <button className="btn btn-sm btn-outline-success mt-auto" onClick={() => manejarSeleccion(op)}>
                      Elegir
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        );
      }

      return (
        <div className="d-flex flex-wrap justify-content-center gap-2 w-100">
          {ultimoMsg.opciones.map((op, idx) => (
            <button key={idx} className="btn btn-success shadow-sm px-4 py-2 fw-bold animate__animated animate__fadeInUp" 
              onClick={() => manejarSeleccion(op)}>
              {op.texto}
            </button>
          ))}
        </div>
      );
    }

    return null;
  };
  return (
    <div className={`vh-100 w-100 d-flex flex-column chat-window-container ${modo}`}>
      <div className="flex-grow-1 d-flex justify-content-center align-items-center">
        <div className="justify-content-center pc-chat-container">
          <div className="d-flex flex-row w-100 h-100">
            
            {/* --- PANEL LATERAL (LINA) --- */}
            <aside className={`d-none d-lg-flex flex-column p-4 character-panel ${modo}`}>
              <div className="character-header text-center mb-4">
                <div className="character-avatar mb-3">
                  <div className={`avatar-border ${modo}`}>
                    <img src={imagenLina} alt="Lina" className="character-img" />
                  </div>
                </div>
                <h2 className={`character-title ${modo}`}>¡Hola! Soy Lina</h2>
                <div className={`character-status ${modo} mt-3`}>
                  <span className="status-dot online"></span>
                  <span className="status-text">En línea</span>
                </div>
              </div>
  
              <div className="character-info mt-4">
                <div className="info-item mb-3">
                  <div className="info-icon"><i className="fas fa-user"></i></div>
                  <div className="info-content">
                    <div className="info-label">Cliente</div>
                    <div className="info-value text-truncate">{nombreCliente}</div>
                  </div>
                </div>
                <div className="info-item">
                  <div className="info-icon"><i className="fas fa-shopping-basket"></i></div>
                  <div className="info-content">
                    <div className="info-label">Estado</div>
                    <div className={`info-value status-${String(estado || 'pendiente').toLowerCase()}`}>
                      {String(estado || 'Iniciando...').replace(/_/g, ' ')}
                    </div>
                  </div>
                </div>
              </div>
            </aside>
  
          {/* --- PANEL PRINCIPAL DE CHAT --- */}
         {/* --- PANEL PRINCIPAL DE CHAT --- */}
         <main className={`chat-main-panel ${modo}`}>
              <header className={`chat-header-enhanced ${modo} shadow-sm`}>
                <div className="chat-header-left d-flex align-items-center w-100 justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="chat-avatar-wrapper">
                      <img src={iconoClavelina} alt="Logo" className="chat-avatar-custom" />
                    </div>
                    <div className="chat-info ms-2">
                      <span className="chat-subtitle d-block">Asistente: Lina</span>
                      
                      {/* 📱 INFO EN MÓVIL: Con el icono del maletincito de compras */}
                      <div className="d-lg-none mt-1" style={{ fontSize: '0.75rem', opacity: 0.9 }}>
                        <span className="me-2 text-white-50">
                          <i className="fas fa-user me-1"></i> {nombreCliente}
                        </span>
                        <span className={`badge bg-light text-dark text-uppercase status-badge-${String(estado || 'pendiente').toLowerCase()}`} style={{ fontSize: '0.65rem' }}>
                          <i className="fas fa-shopping-bag me-1 text-danger"></i> {String(estado || 'Iniciando...').replace(/_/g, ' ')}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="chat-header-right">
                    <button className="modo-toggle-btn border-0 bg-transparent" onClick={() => setModo(modo === "day" ? "night" : "day")}>
                      <i className={`fas ${modo === "day" ? 'fa-moon' : 'fa-sun'}`}></i>
                    </button>
                  </div>
                </div>
              </header>
              {/* Cuerpo de Mensajes */}
              <div className={`chat-messages-container ${modo} p-3`}>
                <div className="messages-wrapper">
                  {messages.map((msg, idx) => (
                    <div key={idx} className={`message-row ${msg.sender === 'user' ? 'user-message-row' : 'bot-message-row'} mb-3 animate__animated animate__fadeInUp`}>
                      {msg.sender === 'bot' && (
                        <div className="message-avatar">
                          <img src={linaChatIcon} alt="Lina" className="message-avatar-img shadow-sm" />
                        </div>
                      )}
                      <div className={`message-bubble ${msg.sender} ${modo} shadow-sm`}>
                        <div className="message-content">
                          {msg.text?.startsWith('data:image/') ? 
                            <img src={msg.text} alt="Capture" className="img-fluid rounded" style={{maxWidth: '180px'}} /> 
                            : msg.text}
                        </div>
                      </div>
                    </div>
                  ))}
  
                  {/* --- RESUMEN FLOTANTE (Solo en estados de decisión) --- */}
                  {['CONFIRMAR_AGREGAR', 'CONFIRMAR_ENVIO', 'METODO_PAGO', 'ESPERANDO_PRECIO'].includes(estado) && (
                    <ResumenPedido 
                      pedidoActual={pedidoActual} 
                      modoEntrega={modoEntrega} 
                      datosEnvio={datosEnvio} 
                    />
                  )}
                  
                  <div ref={chatRef} />
                </div>
              </div>
  
              {/* --- SECCIÓN DE OPCIONES E INTERACCIÓN --- */}
              <section className={`chat-options-enhanced ${modo} p-3 border-top`}>
                <div className="options-grid">
                  {/* Aquí se renderizan tanto tus Cards de productos como los botones de pago */}
                  {renderBotones()}
                </div>
              </section>
  
              {/* --- INPUT DE TEXTO --- */}
              <footer className={`chat-input-enhanced ${modo} p-3`}>
                <div className="input-group-custom d-flex align-items-center w-100">
                  <input 
                    type="text" 
                    className={`message-input w-100 ${modo}`} 
                    placeholder="Escribe aquí..." 
                    value={input} 
                    onChange={e => setInput(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && handleEnviarTexto()} 
                  />
                  
                  {estado === 'PEDIR_CAPTURE' && (
                    <>
                      <input type="file" accept="image/*" onChange={handleCaptureUpload} className="d-none" id="captureUpload" />
                      <label htmlFor="captureUpload" className="btn btn-sm btn-outline-success ms-2">
                        <i className="fas fa-camera"></i>
                      </label>
                    </>
                  )}
  
                  <button 
                    className={`send-btn ms-2 ${input.trim() ? 'active' : ''}`} 
                    onClick={handleEnviarTexto}
                    disabled={!input.trim()}
                  >
                    <i className="fas fa-paper-plane"></i>
                  </button>
                </div>
              </footer>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}